import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1rem 0;

  z-index: 10;

  & > header {
    padding: 0 1rem;
  }
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.grotesk};
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
`;

const StyledLoading = styled.div`
  display: inline-grid;
  font-weight: bold;
  font-family: monospace;
  font-size: 30px;
  justify-content: center;
  margin-top: 8rem;

  &::before,
  &::after {
    content: "Loading...";
    grid-area: 1/1;
    line-height: 1em;
    -webkit-mask: linear-gradient(90deg, #000 50%, #0000 0) 0 50%/2ch 100%;
    -webkit-mask-position: calc(var(--s, 0) * 1ch) 50%;
    animation: loadingAirdrop 2s infinite;
  }
  &::after {
    --s: -1;
  }
  @keyframes loadingAirdrop {
    33% {
      transform: translateY(calc(var(--s, 1) * 50%));
      -webkit-mask-position: calc(var(--s, 0) * 1ch) 50%;
    }
    66% {
      transform: translateY(calc(var(--s, 1) * 50%));
      -webkit-mask-position: calc(var(--s, 0) * 1ch + 1ch) 50%;
    }
    100% {
      transform: translateY(calc(var(--s, 1) * 0%));
      -webkit-mask-position: calc(var(--s, 0) * 1ch + 1ch) 50%;
    }
  }
`;

export default {
  Container,
  Title,
  StyledLoading,
};
